module.exports = __webpack_public_path__ + "4fca6922014b9d857ccd241e50d6faf7.png";


//////////////////
// WEBPACK FOOTER
// ./images/head/programm.png
// module id = 905
// module chunks = 0